import type { RecommendedSkillsData } from 'features/offers/components/RecommendedSkillsModal'

export function buildRecommendedSkillsDataFromAiResponse(
  aiResponse: unknown
): RecommendedSkillsData | null {
  if (!aiResponse || typeof aiResponse !== 'object') return null

  const response = aiResponse as Record<string, unknown>
  const data: RecommendedSkillsData = {
    hard_skills_mentionnées: (response.hard_skills_mentionnées as string[]) ?? [],
    hard_skills_non_mentionnées: (response.hard_skills_non_mentionnées as string[]) ?? [],
    soft_skills_mentionnées: (response.soft_skills_mentionnées as string[]) ?? [],
    soft_skills_non_mentionnées: (response.soft_skills_non_mentionnées as string[]) ?? [],
    nice_to_have_mentionnées: (response.nice_to_have_mentionnées as string[]) ?? [],
    nice_to_have_non_mentionnées: (response.nice_to_have_non_mentionnées as string[]) ?? [],
  }

  const hasSkills = [
    data.hard_skills_mentionnées,
    data.hard_skills_non_mentionnées,
    data.soft_skills_mentionnées,
    data.soft_skills_non_mentionnées,
    data.nice_to_have_mentionnées,
    data.nice_to_have_non_mentionnées,
  ].some(skills => (skills?.length ?? 0) > 0)

  return hasSkills ? data : null
}
